var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{on:{"click":_vm.toggleTheme}},[_c('feather-icon',{attrs:{"size":"21","icon":_vm.isDark ? 'SunIcon' : 'MoonIcon'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }